module.exports = __webpack_public_path__ + "img/readmission.592f2632.svg";